import React, {
  useCallback,
  useEffect,
  useReducer,
  useRef,
  useState,
} from "react";
import {
  Button,
  Card,
  Col,
  Divider,
  Empty,
  message,
  Modal,
  Row,
  Space,
} from "antd";
import "./AIForm.scss";
import scrollIntoView from "scroll-into-view-if-needed";
import { doc, setDoc, onSnapshot, getDoc } from "firebase/firestore";
import { db } from "firebase";
import SpeechRecognition from "react-speech-recognition";
import api from "utils/api";
import SpeechToTextComponent from "Components/SpeechToTextComponent";
import utils from "utils";
import ChimeTranscript from "./ChimeTranscript";
import CustomDrawer from "Components/CustomDrawer/CustomDrawer";
import TextLoading from "Components/TextLoading/TextLoading";
import { IconMicAi } from "Common/ReactIcons";
import AIFormCombinedView from "./AIFormCombinedView";
let textId = 1;
let questionsObj = {};

// const SAMPLE_AI_RSLT_DATA = {
//   group_id_0: {
//     group_id: 0,
//     group_result: [
//       // {
//       //   is_accepted: false,
//       //   title: "mensuration_detail",
//       //   is_reviewed: false,
//       //   value: {
//       //     if_irregular: "",
//       //     mensurational_cycle: "Regular",
//       //   },
//       //   id: 2466,
//       //   is_rejected: false,
//       //   label: "mensuration_cycle",
//       // },
//       // {
//       //   label: "mensuration_cramp",
//       //   is_rejected: false,
//       //   id: 2467,
//       //   title: "mensuration_detail",
//       //   is_accepted: false,
//       //   value: {
//       //     medication: [],
//       //     if_cramps: "",
//       //     if_mensuration_cramp: true,
//       //   },
//       //   is_reviewed: false,
//       // },
//       {
//         label: "mood_change",
//         value: {
//           if_mood_change: true,
//           is_mood: false,
//           medication: [
//             {
//               medication_value: "value 1",
//             },
//             {
//               medication_value: "value 2",
//             },
//             {
//               medication_value: "value 3",
//             },
//           ],
//         },
//         title: "mensuration_detail",
//         id: 2468,
//         is_accepted: false,
//         is_rejected: false,
//         is_reviewed: false,
//       },
//       // {
//       //   is_accepted: false,
//       //   value: {
//       //     delivery_depression: {
//       //       post_delivery_medication: [
//       //         {
//       //           medication_value: "",
//       //         },
//       //         {
//       //           medication_value: "",
//       //         },
//       //       ],
//       //       post_delivery_depression: false,
//       //     },
//       //     delivery: "normal",
//       //     delivery_psychosis: {
//       //       post_delivery_psychosis_medication: [],
//       //       post_delivery_psychosis: "",
//       //     },
//       //   },
//       //   is_rejected: false,
//       //   title: "mensuration_detail",
//       //   label: "delivery",
//       //   id: 2469,
//       //   is_reviewed: false,
//       // },
//       // {
//       //   value: {
//       //     medication: [
//       //       {
//       //         medication_value: "hh",
//       //       },
//       //       {
//       //         medication_value: "",
//       //       },
//       //     ],
//       //     is_menopause: false,
//       //     hormonal_replacement_theraphy: true,
//       //   },
//       //   label: "menopause",
//       //   is_reviewed: false,
//       //   title: "mensuration_detail",
//       //   id: 2470,
//       //   is_rejected: false,
//       //   is_accepted: false,
//       // },
//       // {
//       //   is_reviewed: false,
//       //   is_accepted: false,
//       //   label: "hysterectomy",
//       //   is_rejected: false,
//       //   title: "mensuration_detail",
//       //   value: {
//       //     medication: [
//       //       {
//       //         medication_value: "",
//       //       },
//       //     ],
//       //     is_hysterectomy: false,
//       //   },
//       //   id: 2471,
//       // },
//       // {
//       //   label: "pcos",
//       //   id: 2472,
//       //   title: "mensuration_detail",
//       //   value: {
//       //     medication: [
//       //       {
//       //         medication_value: "",
//       //       },
//       //       {
//       //         medication_value: "",
//       //       },
//       //     ],
//       //     is_pcos: true,
//       //   },
//       //   is_rejected: false,
//       //   is_reviewed: false,
//       //   is_accepted: false,
//       // },
//       // {
//       //   is_reviewed: false,
//       //   is_rejected: false,
//       //   value: {
//       //     medication: [],
//       //     is_fibroid: true,
//       //   },
//       //   label: "fibroid",
//       //   is_accepted: false,
//       //   id: 2473,
//       //   title: "mensuration_detail",
//       // },
//       // {
//       //   title: "mensuration_detail",
//       //   value: {
//       //     is_oral_contraceptive: true,
//       //     medication: [
//       //       {
//       //         medication_value: "12",
//       //         duration_period: 12,
//       //         duration: 3,
//       //       },
//       //     ],
//       //   },
//       //   id: 2474,
//       //   is_reviewed: false,
//       //   label: "oral_contraceptive",
//       //   is_accepted: false,
//       //   is_rejected: false,
//       // },
//     ],
//   },
// };

// const SAMPLE_AI_RSLT_DATA = {
//   group_id_1: {
//     group_result: [
//       {
//         is_rejected: false,
//         is_exist: true,
//         is_accepted: false,
//         label: "sleep_routine",
//         title: "sleep_detail",
//         is_reviewed: false,
//         id: 1980,
//         value: "good",
//       },
//       {
//         label: "feeling_drowsy",
//         is_rejected: false,
//         title: "sleep_detail",
//         id: 1981,
//         value: "yes",
//         is_accepted: false,
//         is_reviewed: false,
//       },
//       {
//         is_reviewed: false,
//         id: 1982,
//         value: "Snoring",
//         title: "sleep_detail",
//         is_rejected: false,
//         label: "sleeping_habit",
//         is_accepted: false,
//       },
//     ],
//     group_id: 1,
//   },
//   // group_id_0: {
//   //   group_result: [
//   //     {
//   //       value: "low",
//   //       is_reviewed: false,
//   //       label: "energy_level",
//   //       is_accepted: false,
//   //       id: 1977,
//   //       title: "energy_exercise",
//   //       is_rejected: false,
//   //     },
//   //     {
//   //       is_rejected: false,
//   //       title: "energy_exercise",
//   //       value: {
//   //         type_of_exercise: ["Running"],
//   //         if_other: "",
//   //       },
//   //       is_reviewed: false,
//   //       is_accepted: false,
//   //       id: 1978,
//   //       label: "exercise",
//   //     },
//   //     {
//   //       is_reviewed: false,
//   //       value: "Regular",
//   //       is_rejected: false,
//   //       id: 1979,
//   //       label: "exercise_routine",
//   //       title: "energy_exercise",
//   //       is_accepted: false,
//   //     },
//   //   ],
//   //   group_id: 0,
//   // },
//   group_id_2: {
//     group_result: [
//       {
//         label: "onset_first_concern",
//         is_reviewed: false,
//         id: 1983,
//         is_accepted: false,
//         is_rejected: false,
//         is_exist: true,
//         value: {
//           is_onset_first_concern: true,
//           onset_first_concern_value: "August 2023",
//         },
//         title: "presenting_mental_health_complaints",
//       },
//       {
//         value: {
//           recurrent_value: "",
//           is_recurrent: false,
//         },
//         title: "presenting_mental_health_complaints",
//         is_accepted: false,
//         label: "recurrent",
//         id: 1984,
//         is_rejected: false,
//         is_reviewed: false,
//         is_exist: true,
//       },
//       {
//         value: "No",
//         id: 1985,
//         is_accepted: false,
//         is_reviewed: false,
//         label: "self_harm_suicide_attempt",
//         title: "presenting_mental_health_complaints",
//         is_rejected: false,
//         displayValue: "No",
//         is_exist: true,
//       },
//       {
//         is_rejected: false,
//         title: "presenting_mental_health_complaints",
//         is_accepted: false,
//         id: 1986,
//         label: "marital_disorder",
//         value: "No",
//         is_reviewed: false,
//         displayValue: "No",
//       },
//       {
//         id: 1987,
//         is_accepted: false,
//         value: {
//           emotional_abuse: {
//             emotional_abuse_value:
//               "Experienced emotional abuse in the workplace",
//             is_emotional_abuse: true,
//           },
//           sexual_abuse: {
//             sexual_abuse_value: "",
//             is_sexual_abuse: false,
//           },
//           physical_abuse: {
//             physical_abuse_value: "Physically abused in childhood",
//             is_physical_abuse: true,
//           },
//           is_abuse: true,
//         },
//         is_reviewed: false,
//         label: "abuse",
//         title: "presenting_mental_health_complaints",
//         is_rejected: false,
//       },
//       {
//         is_accepted: false,
//         title: "presenting_mental_health_complaints",
//         label: "substance_dependence",
//         value: {
//           is_substance_dependence: true,
//           drugs: {
//             quantity: "1",
//             abstinence: {
//               is_abstinence: false,
//               since: "",
//               reason_for_relapse: "",
//             },
//             frequency: 3,
//             duration_period: "1",
//             is_drugs: true,
//             symptoms: [3],
//             duration: 3,
//           },
//           smoking: {
//             is_smoking: false,
//             quantity: "",
//             frequency: null,
//             duration_period: "",
//             symptoms: [],
//             abstinence: {
//               reason_for_relapse: "",
//               is_abstinence: false,
//               since: "",
//             },
//             duration: null,
//           },
//           alcohol: {
//             duration: null,
//             frequency: null,
//             abstinence: {
//               since: "",
//               is_abstinence: false,
//               reason_for_relapse: "",
//             },
//             duration_period: "",
//             is_alcohol: false,
//             symptoms: [],
//             quantity: "",
//           },
//           cannabis: {
//             duration: null,
//             duration_period: "",
//             frequency: null,
//             is_cannabis: false,
//             abstinence: {
//               reason_for_relapse: "",
//               since: "",
//               is_abstinence: false,
//             },
//             symptoms: [],
//             quantity: "",
//           },
//         },
//         is_reviewed: false,
//         id: 1988,
//         is_rejected: false,
//       },
//     ],
//     group_id: 2,
//   },
// };

// const tmpData = [
//   "tmp txt",
//   "how is your energy level my energy level are low what type of exercise is being followed Running How is the exercise routine my exercise routine in regular",
//   "How is the sleep Routine my sleep routine are good tell me about your Sleeping habit my sleep hablit are snoring do you feel drowsy during the day time yes i do feel drowsy during day",
//   "Hi lets discuss about Presenting Health Complaints now tell me,have you experienced abuse yes have experienced can you please explain about that one yeah sure i hava abused physically in my childhood and experienced emotional abuse in my work place because my of co employee and  specific areas of your life do you feel you would like to see improvement i would like to see improvement in Conflict Resolution and Marital & Family Relationships and Procrastination and Avoidance",
// ];

const AIForm = ({
  isSpeaking,
  showAIForm,
  roomName,
  appointment_utc_date_time,
  patient_id,
  handleFBDocFinish,
  chime_enabled = false,
  is_editable = true,
  showTrans = false,
  transModal = () => {},
  setTransText = () => {},
  transtext = "",
}) => {
  const [aiFormData, steAIFormData] = useState([]);
  const [loading, setLoading] = useState(false);
  const groupResultsRef = useRef(null);
  const isDocCreated = useRef(false);
  const initialFetchCompleteRef = useRef(false);
  const docName = roomName + appointment_utc_date_time;
  const writeDocPath = `${docName}_write_collection/${docName}_write_document`;
  const listenDocPath = `${docName}_listen_collection/${docName}_listen_document`;
  // const endMessageFAQ = useRef(null);
  const timeoutsRef = useRef([]);
  const parentDivRef = useRef(null);
  const TransText = (text) => {
    setTransText((prev) => prev + " " + text);
  };
  const firebase_length = useRef(null);
  useEffect(() => {
    if (parentDivRef.current) {
      parentDivRef.current?.scrollIntoView({ behavior: "smooth" });
    }
  }, [transtext, showTrans]);
  const loopThroughResults = useCallback((results, index = 0) => {
    if (index < results.length) {
      // steAIFormData((prevArray) => sortData([results[index], ...prevArray]));
      steAIFormData((prevArray) => [results[index], ...prevArray]);
      // scrollToMessages();
      const timeoutId = setTimeout(() => {
        loopThroughResults(results, index + 1);
      }, 1000); // Wait for 3 seconds before adding the next item

      timeoutsRef.current.push(timeoutId);
    }
  }, []);
  // const scrollToMessageBottom = () => {
  //   console.log(
  //     document.getElementById(`message-list-item-${aiFormData?.length - 2}`)
  //   );
  //   if (document.getElementById(`message-list-item-${aiFormData?.length - 2}`))
  //     scrollIntoView(
  //       document.getElementById(`message-list-item-${aiFormData?.length - 2}`),
  //       {
  //         behavior: "instant",
  //         scrollMode: "if-needed",
  //         boundary: document.getElementById("message-container"),
  //       }
  //     );
  // };

  const createFirebaseDoc = () => {
    let payloadData = {
      listen_collection: {
        collection_name: `${docName}_listen_collection`,
        document_name: `${docName}_listen_document`,
      },
      write_data_collection: {
        collection_name: `${docName}_write_collection`,
        document_name: `${docName}_write_document`,
      },
    };

    console.log("Payload data");
    console.log(payloadData);

    api
      .create_firebase_doc(payloadData)
      .then((res) => {
        if (res.status == 200) {
          isDocCreated.current = true;
          handleFBDocFinish();
        }
      })
      .catch((error) => {
        console.log(error);
      });
  };

  // const scrollToMessages = () => {
  //   endMessageFAQ.current?.scrollIntoView({ behavior: "smooth" });
  // };

  const getAllReviewedForms = () => {
    setLoading(true);
    const payloadData = {
      appointment_id: roomName,
    };
    api
      .get_transcripted_data({ app_id: roomName })
      .then((res) => {
        if (res.data.status == 200)
          setTransText(res?.data?.data?.transcription);
      })
      .catch((error) => {
        message.error("Something went wrong");
      });
    api
      .get_reviewed_forms(payloadData)
      .then((res) => {
        let { data: savedItems = [] } = res?.data;

        const sortByIdDesc = (a, b) => b.id - a.id;

        const acceptedData = sortData(
          savedItems.filter((item) => item.is_accepted)
        );
        // .sort(sortByIdDesc);
        const rejectedData = sortData(
          savedItems.filter((item) => item.is_rejected)
        );
        // .sort(sortByIdDesc);
        const otherData = sortData(
          savedItems.filter((item) => !item.is_accepted && !item.is_rejected)
        );
        // .sort(sortByIdDesc);
        // const reviewedItems = filterEmptyValues([
        //   ...acceptedData,
        //   ...rejectedData,
        //   ...otherData,
        // ]);
        const reviewedItems = [...acceptedData, ...rejectedData, ...otherData];
        for (const resultItem of reviewedItems) {
          if (Array.isArray(resultItem.value)) {
            resultItem.displayValue = resultItem.value.join(", ");
          } else if (typeof resultItem.value !== "object") {
            resultItem.displayValue = resultItem.value;
          }
          resultItem.isSaved = true;
        }
        setLoading(false);
        steAIFormData(reviewedItems);
        // loopThroughResults(reviewedItems);
        if (reviewedItems.length > 0) {
          // scrollToMessages();
        }
      })
      .catch((error) => {
        message.error("Something went wrong");
      });
  };

  useEffect(() => {
    if (chime_enabled) {
      getAllReviewedForms();
    }
    // let latestResults = Object.entries(SAMPLE_AI_RSLT_DATA).sort(
    //   (a, b) => b[1].group_id - a[1].group_id
    //   // (a, b) => a[1].group_id - b[1].group_id
    // )[0][1];
    // steAIFormData(latestResults.group_result);
    // for (const resultItem of latestResults.group_result) {
    //   if (typeof resultItem.value === "object") {
    //     // const data = processObject(resultItem.value);
    //     // console.log("processed object");
    //     // console.log(data);
    //   } else {
    //   }
    return () => {
      timeoutsRef.current.forEach((timeoutId) => clearTimeout(timeoutId));
    };
  }, []);

  const updateDatainFireBase = () => {
    console.log("Data going to load in firebase");
    console.log(groupResultsRef.current);

    if (groupResultsRef.current) {
      if (chime_enabled) {
        questionsObj = {
          ...questionsObj,
          // [`trans_${textId}`]: groupResultsRef.current,
          [`trans_${textId}`]:
            (questionsObj[`trans_${textId - 1}`]
              ? utils.extractAfterLastSentenceDelimiter(
                  questionsObj[`trans_${textId - 1}`]
                ) + " "
              : "") + groupResultsRef.current,
        };
      } else {
        questionsObj = {
          ...questionsObj,
          // [`trans_${textId}`]: groupResultsRef.current,
          [`trans_${textId}`]:
            (questionsObj[`trans_${textId - 1}`]
              ? questionsObj[`trans_${textId - 1}`].slice(
                  -Math.ceil(questionsObj[`trans_${textId - 1}`].length * 0.25)
                ) + " "
              : "") + groupResultsRef.current,
        };
      }

      console.log("Question Obj");
      console.log(questionsObj);
      setDoc(doc(db, writeDocPath), questionsObj)
        .then(() => {
          console.log("Question Obj");
          console.log(questionsObj);
          console.log("Document successfully written!");
          groupResultsRef.current = null;
        })
        .catch((error) => {
          console.error("Error writing document: ", error);
          message.error("Error writing document ");
        });
      textId++;
    }

    // setDoc(doc(db, writeDocPath), questionsObj)
    //   .then(() => {
    //     console.log("Question Obj");
    //     console.log(questionsObj);
    //     console.log("Document successfully written!");
    //   })
    //   .catch((error) => {
    //     console.error("Error writing document: ", error);
    //   });

    // }
  };

  const prePareTranscribeText = () => {
    // const recognition = SpeechRecognition.getRecognition();
    // recognition.interimResults = false;
    // recognition.continuous = true;

    // recognition.onaudioend = (event) => {
    //   console.log("##### onaudioend ######");
    //   console.log(event);
    //   console.log("########3######");
    // };

    // recognition.onend = (event) => {
    //   console.log("##### onend ######");
    //   console.log(event);
    //   console.log("###########");
    // };

    // recognition.onerror = (event) => {
    //   console.log("##### onerror ######");
    //   console.log(event);
    //   console.log("############");
    // };

    // recognition.onnomatch = (event) => {
    //   console.log("##### onnomatch ######");
    //   console.log(event);
    //   console.log("#############");
    // };

    // recognition.onsoundend = (event) => {
    //   console.log("##### onsoundend ######");
    //   console.log(event);
    //   console.log("#############");
    // };

    // recognition.onresult = (event) => {
    //   console.log("##### Final Result ######");
    //   console.log(event);
    //   const length = event.results.length;
    //   console.log(event.results[length - 1][0].transcript);
    //   console.log("#############");
    //   if (event?.results[0].isFinal) {
    //     updateDatainFireBase(event.results[length - 1][0].transcript);
    //   }
    // };

    // recognition.onspeechend = (e) => {
    //   console.log("##### onspeechend ######");
    //   console.log(e);
    //   console.log("###########");
    // };
    try {
      onSnapshot(doc(db, listenDocPath), (docsSnap) => {
        if (initialFetchCompleteRef.current) {
          console.log("##################");
          console.log("Document listened and data is below");
          let data = docsSnap.data();
          console.log(data);
          if (firebase_length.current == Object.keys(data || {}).length) {
            return;
          }
          firebase_length.current = Object.keys(data || {}).length;
          if (Object.keys(data || {}).length !== 0) {
            let result = Object.entries(data).sort(
              (a, b) => b[1].group_id - a[1].group_id
            )[0][1];

            for (const resultItem of result.group_result) {
              if (Array.isArray(resultItem.value)) {
                resultItem.displayValue = resultItem.value.join(", ");
              } else if (typeof resultItem.value !== "object") {
                resultItem.displayValue = resultItem.value;
              }
            }
            // loopThroughResults(filterEmptyValues(result.group_result));
            loopThroughResults(result.group_result);
            // steAIFormData((prevArray) => [...result.group_result, ...prevArray]);
            // scrollToMessages();
          }
        } else {
          initialFetchCompleteRef.current = true;
        }
      });
    } catch (error) {
      console.log(`${error}`);
      message.error("Error on firebase document listing");
    }
  };

  useEffect(() => {
    if (showAIForm && !isDocCreated.current) {
      const docRef = doc(
        db,
        `${docName}_write_collection`,
        `${docName}_write_document`
      );
      getDoc(docRef)
        .then((docSnap) => {
          if (!docSnap.exists()) {
            createFirebaseDoc();
          } else {
            isDocCreated.current = true;
            handleFBDocFinish();
          }
          questionsObj = {};
        })
        .catch((error) => {
          console.log(error);
          message.error("Error on Firebase");
        });
    } else if (showAIForm) {
      initialFetchCompleteRef.current = false;
      handleFBDocFinish();
    } else {
      if (!chime_enabled) {
        textId = 1;
      }
    }
  }, [showAIForm]);

  // useEffect(() => {

  //   if(!isSpeaking) {

  //   }
  // }, [isSpeaking]);

  useEffect(() => {
    // const intervalId = setInterval(() => {
    //   updateDatainFireBase();

    // let data = SAMPLE_AI_RSLT_DATA;

    // if (Object.keys(data).length !== 0) {
    //   let result = Object.entries(data).sort(
    //     (a, b) => b[1].group_id - a[1].group_id
    //   )[0][1];

    //   for (const resultItem of result.group_result) {
    //     if (Array.isArray(resultItem.value)) {
    //       resultItem.displayValue = resultItem.value.join(", ");
    //       // resultItem.label = resultItem.label.replace(/_/g, "");
    //     } else if (typeof resultItem.value !== "object") {
    //       resultItem.displayValue = resultItem.value;
    //       // resultItem.label = resultItem.label.replace(/_/g, "");
    //     }
    //   }

    //   steAIFormData((prevArray) => [...prevArray, ...result.group_result]);

    // let result = Object.entries(data).sort(
    //   (a, b) => b[1].group_id - a[1].group_id
    // )[0][1];

    // console.log("resultitem data");
    // console.log(result);

    // for (const resultItem of result.group_result) {
    //   if (Array.isArray(resultItem.value)) {
    //     resultItem.displayValue = resultItem.value.join(", ");
    //   } else if (typeof resultItem.value !== "object") {
    //     resultItem.displayValue = resultItem.value;
    //   }
    // }

    // steAIFormData((prevArray) => [...prevArray, ...result.group_result]);
    // }
    // }, 60000); // 60,000 milliseconds = 1 minute

    if (isSpeaking && showAIForm) {
      prePareTranscribeText();
    }
  }, [isSpeaking, showAIForm]);

  // useEffect(() => {}, []);

  useEffect(() => {
    return () => {
      if (isDocCreated.current) {
        let payloadData = {
          listen_collection: {
            collection_name: `${docName}_listen_collection`,
            document_name: `${docName}_listen_document`,
          },
          write_data_collection: {
            collection_name: `${docName}_write_collection`,
            document_name: `${docName}_write_document`,
          },
        };

        api
          .delete_firebase_doc(payloadData)
          .then((res) => {})
          .catch((error) => {
            console.log("Error in document delete");
          });
      }
    };
  }, []);
  const updateFormField = (value) => {
    console.log("transcript received");
    console.log(value);
    if (value) {
      groupResultsRef.current = value;
      // TransText(value);
    }
  };
  return (
    <>
      <AIFormCombinedView
        loading={loading}
        aiFormData={aiFormData}
        steAIFormData={steAIFormData}
        is_editable={is_editable}
        isSpeaking={isSpeaking}
        chime_enabled={chime_enabled}
        setLoading={setLoading}
        getAllReviewedForms={getAllReviewedForms}
        patient_id={patient_id}
        is_review_screen={false}
      />
      {chime_enabled ? (
        <ChimeTranscript
          isBackgroundListen={true}
          listenAudio={isSpeaking}
          updateFormField={updateFormField}
          clearLength={() => {}}
          updateDatainFireBase={updateDatainFireBase}
          TransText={TransText}
        />
      ) : (
        <SpeechToTextComponent
          isBackgroundListen={true}
          listenAudio={isSpeaking}
          updateFormField={updateFormField}
          clearLength={() => {}}
          updateDatainFireBase={updateDatainFireBase}
          TransText={TransText}
        />
      )}
      <CustomDrawer
        visible={showTrans}
        title="Trancription"
        placement="bottom" /* Can be bottom, top, left, or right */
        onClose={transModal}
        height="300px" /* Adjust height for bottom and top placements */
        width="100%" /* Adjust width for left and right placements */
      >
        <div style={{ marginBottom: "20px" }}>
          {/* {transtext} */}
          {transtext.split(/(?<=\.|\?)/).map((sentence, index) => (
            <p key={index}>{sentence.trim()}</p>
          ))}
          <div ref={parentDivRef}></div>
        </div>
        <div style={{ display: "flex" }}>
          <IconMicAi style={{ marginRight: "10px" }} />
          {isSpeaking && <TextLoading />}
        </div>
      </CustomDrawer>
    </>
  );
};
export function sortData(data) {
  const titleOrder = [
    "socio_demographic_detail",
    "presenting_mental_health_compl",
    "presenting_complaints",
    "physical_health_complaints",
    "past_hospitalization_history",
    "physical_illness_in_the_family",
    "mensuration_detail",
    "educational_details",
    "occupational_details",
    "sexual_health",
  ];

  return data.sort((a, b) => {
    const titleComparison =
      titleOrder.indexOf(a.title) - titleOrder.indexOf(b.title);
    if (titleComparison !== 0) {
      return titleComparison;
    }
    return a.label.localeCompare(b.label);
  });
}

export default AIForm;
